import el from "@cypherpotato/el";
import { Definition, DefinitionList } from "./definition";
import { formatFloat, formatNumber } from "../ui/format";
import { getUniqueColor } from "../ui/unique-color";

function WaterfallRow(label, startMs, durationMs, totalMs) {
    const leftPct = Math.max((startMs / totalMs) * 100, 0);
    const widthPct = Math.max((durationMs / totalMs) * 100, 0.3);

    return el(".perf-waterfall-row",
        el(".perf-waterfall-label", label),
        el(".perf-waterfall-track",
            el(".perf-waterfall-bar", {
                style: {
                    left: leftPct + "%",
                    width: widthPct + "%",
                    backgroundColor: getUniqueColor(label)
                }
            })
        ),
        el(".perf-waterfall-duration", formatNumber(durationMs) + "ms")
    );
}

export function PerfWaterfall({ performance }) {
    const {
        connection_latency,
        time_to_first_token,
        tokens_per_second,
        reasoning_time,
        answer_time,
        total_time
    } = performance;

    const connectionMs = Math.max(Number(connection_latency) || 0, 0);
    const firstTokenMs = Math.max(Number(time_to_first_token) || 0, 0);
    const reasoningMs = Math.max(Number(reasoning_time) || 0, 0);
    const answerMs = Math.max(Number(answer_time) || 0, 0);
    const totalMs = Math.max(Number(total_time) || 0, 0);
    const reasoningStartMs = Math.max(Number(performance.reasoning_start_time) || (reasoningMs > 0 ? firstTokenMs : 0), 0);
    const answerStartMs = Math.max(Number(performance.answer_start_time) || (answerMs > 0 ? totalMs - answerMs : 0), 0);
    const timelineTotalMs = Math.max(totalMs, firstTokenMs, connectionMs, reasoningStartMs + reasoningMs, answerStartMs + answerMs, 1);

    const rows = [
        connectionMs > 0 && ["Connection", 0, connectionMs],
        firstTokenMs > connectionMs && ["First token wait", connectionMs, firstTokenMs - connectionMs],
        reasoningMs > 0 && ["Reasoning", reasoningStartMs, reasoningMs],
        answerMs > 0 && ["Answer", answerStartMs, answerMs]
    ].filter(Boolean);

    const ticks = [0, 0.5, 1].map(ratio => {
        const pct = ratio * 100;
        return el(".perf-waterfall-tick", { style: { left: pct + "%" } },
            el("span", formatNumber(Math.round(ratio * timelineTotalMs)) + "ms")
        );
    });

    return el(".perf-waterfall",
        el(".perf-waterfall-chart",
            ...rows.map(([label, startMs, durationMs]) =>
                WaterfallRow(label, startMs, durationMs, timelineTotalMs)
            ),
            el(".perf-waterfall-ruler", ...ticks)
        ),
        DefinitionList(
            Definition("Time to first token", formatNumber(firstTokenMs) + "ms"),
            Definition("Total time", formatNumber(totalMs) + "ms"),
            tokens_per_second > 0 && Definition("Output speed", formatFloat(tokens_per_second) + " tokens/s")
        )
    );
}
